import PlateAppearanceResult from '../enums/PlateAppearanceResult.js';

// based on http://m.mlb.com/glossary/standard-stats/total-bases
const plateAppearanceResultToBaseNumberConverter = function(paResult) {
    switch (paResult) {
        case PlateAppearanceResult.Single.key:
            return 1;
        case PlateAppearanceResult.Double.key:
        case PlateAppearanceResult.GroundRuleDouble.key:
            return 2;
        case PlateAppearanceResult.Triple.key:
            return 3;
        case PlateAppearanceResult.HomeRun.key:
        case PlateAppearanceResult.InsideTheParkHomeRun.key:
            return 4;
        default:
            return 0;
    }
};

export default plateAppearanceResultToBaseNumberConverter;